// Auto-generated normalizer for table: ZonasGeograficas
export function zonasGeograficasNormalize(row) {
  return {
    idZonaGeografica: row.idZonaGeografica ?? row.IdZonaGeografica ?? row["idZonaGeografica"] ?? row["IdZonaGeografica"] ?? 0,
    clave: row.clave ?? row.Clave ?? row["clave"] ?? row["Clave"] ?? "",
    nombre: row.nombre ?? row.Nombre ?? row["nombre"] ?? row["Nombre"] ?? "",
    descripcion: row.descripcion ?? row.Descripcion ?? row["descripcion"] ?? row["Descripcion"] ?? "",
    activo: row.activo ?? row.Activo ?? row["activo"] ?? row["Activo"] ?? true,
  };
}
